export const PanoGroupIconV2 = ({ className }: React.SVGAttributes<React.ReactSVGElement>) => {
  return (
    <svg
      className={className}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.26742 7.05972V3.01475C2.18447 3.49319 0.847656 4.22388 0.847656 5.04158C0.847656 6.46819 4.9436 7.65124 10.0033 7.65124C15.063 7.65124 19.1589 6.49429 19.1589 5.04158C19.1589 4.17169 17.7366 3.44969 15.5371 2.97125V7.10322"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.42861"
      />
      <path
        d="M19.1511 5.04181V14.4192C19.1511 15.8545 15.0474 17.0289 9.99549 17.0289C4.94356 17.0289 0.839844 15.8719 0.839844 14.4192V5.04181"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.42861"
      />
      <path
        d="M3.57617 16.2719L7.95969 10.2523L10.9158 16.5962"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.42861"
      />
      <path
        d="M15.5214 16.4894L11.5809 11.0265L9.67676 13.4274"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.42861"
      />
      <path
        d="M14.7839 11.2786C15.2346 11.2786 15.5999 10.8697 15.5999 10.3652C15.5999 9.86078 15.2346 9.45184 14.7839 9.45184C14.3331 9.45184 13.9678 9.86078 13.9678 10.3652C13.9678 10.8697 14.3331 11.2786 14.7839 11.2786Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.714303"
      />
    </svg>
  );
};
